module.exports = __webpack_public_path__ + "img/any-mbg3.a8806aff.png";